const NAMESPACE = "resendContactInfoPreview";

const KEYS = {
    contactInfoUpdatedText: "contactInfoUpdatedText",
    contactInfoOriginalText: "contactInfoOriginalText",
    formattedContactInfoTemplate: "formattedContactInfoTemplate",
    missingContactInfoPlaceholder: "missingContactInfoPlaceholder",
    showOriginalContactInfoBtnLabel: "showOriginalContactInfoBtnLabel",
    hideOriginalContactInfoBtnLabel: "hideOriginalContactInfoBtnLabel"
};

const MESSAGES = {
    [KEYS.contactInfoUpdatedText]: {
        value: "Updated",
        comment: "Indication that a recipient's contact info has been updated"
    },
    [KEYS.contactInfoOriginalText]: {
        value: "Original",
        comment: "Text for an indicator when showing the original contact info of a recipient"
    },
    [KEYS.formattedContactInfoTemplate]: {
        value: "{first} {last} ({email})",
        comment: "Template for the recipient's contact info formatted as a string"
    },
    [KEYS.missingContactInfoPlaceholder]: {
        value: "<Missing>",
        comment: "Placeholder for missing signatory contact info"
    },
    [KEYS.showOriginalContactInfoBtnLabel]: {
        value: "View original contact info",
        comment: "Label for button to show original contact info"
    },
    [KEYS.hideOriginalContactInfoBtnLabel]: {
        value: "Hide",
        comment: "Label for button to hide original contact info"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
